import {Permissions} from './config'
import {usePermissions} from './PermissionsContext'

export const withPermission = (reqPermissions: string[]) => {
  const {permissions} = usePermissions()

  // Check if user has required permissions
  return checkPermission(reqPermissions, permissions)
}

export const checkPermission = (
  reqPermissions: string[],
  userPermissions: Permissions,
) => {
  if (!userPermissions) return false

  if (userPermissions === '*') return true

  // Check if user has required permissions
  const hasPermission = reqPermissions.every(perm =>
    userPermissions.includes(perm),
  )

  return hasPermission
}
